import { CsUnavailable } from './cs-unavailable.component';

export const CsUnavailableContainer = ({
  heading = 'Sorry, there seems to be a problem',
  subHeading = 'In the meantime explore our site to learn more about community solar.',
}) => {
  return <CsUnavailable heading={heading} subHeading={subHeading} />;
};
